import { httpClient } from "@/httpClient";
import getPharmacyID from "@/utils/pharmacy_code";
import { GetMedicalItemsWithStockByPharmacyRowSchema, GetNonMedicalItemsWithStockByPharmacyRowSchema, TransferItemRequest, UpsertMedicalInventoryStockParams } from "./type";
import { pharmacyClient } from "@/connect";
import { GetMedicalInventoryStockResponse } from "@/gen/onboarding/get_medical_inventory_stock_pb";
import { GetNonMedicalInventoryStockResponse } from "@/gen/onboarding/get_non_medical_inventory_stock_pb";
import { TransferItemResponse } from "@/gen/onboarding/transfer_item_pb";
import { UpsertMedicalInventoryResponse } from "@/gen/onboarding/upsert_medical_inventory_pb";

export const getMedicalStock = async (
    page: number, 
    pageSize: number, 
    search: string = ''
): Promise<GetMedicalInventoryStockResponse> => {
    return await pharmacyClient.getMedicalInventoryStock({
        pageNumber: page,
        pageSize,
        search,
    });
};

export const getNonMedicalStock = async (
    page: number, 
    pageSize: number, 
    search: string = ''
): Promise<GetNonMedicalInventoryStockResponse> => {
    return await pharmacyClient.getNonMedicalInventoryStock({
        pageNumber: page,
        pageSize,
        search,
    });
};

export const transferMedicalItem = async (
    sourceNonMedicalMasterId: string,
    targetMedicalMasterId: string,
    barcode: string
): Promise<TransferItemResponse> => {
    return await pharmacyClient.transferItem({
        sourceNonMedicalMasterId,
        targetMedicalMasterId,
        barcode,
    });
};

export const updateMedicalItem = async (
    medicalMasterId: string,
    quantity: { original: number; bonus: number },
    batchNumber: string,
    expiryDate: string, // YYYY-MM-DD format
    cost: number,
    productionDate?: string // YYYY-MM-DD format
): Promise<UpsertMedicalInventoryResponse> => {
    return await pharmacyClient.upsertMedicalInventoryStock({
        medicalMasterId,
        quantity,
        batchNumber,
        expiryDate,
        cost,
        productionDate,
    });
};